
// @ts-nocheck
import locale_en_46json_17871154 from "#nuxt-i18n/17871154";
import locale_errors_46json_f00f26c2 from "#nuxt-i18n/f00f26c2";
import locale_pt_46json_4f41fc18 from "#nuxt-i18n/4f41fc18";
import locale_errors_46json_2e83de1c from "#nuxt-i18n/2e83de1c";

export const localeCodes =  [
  "en",
  "pt"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_17871154",
      load: () => Promise.resolve(locale_en_46json_17871154),
      cache: true
    },
    {
      key: "locale_errors_46json_f00f26c2",
      load: () => Promise.resolve(locale_errors_46json_f00f26c2),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_4f41fc18",
      load: () => Promise.resolve(locale_pt_46json_4f41fc18),
      cache: true
    },
    {
      key: "locale_errors_46json_2e83de1c",
      load: () => Promise.resolve(locale_errors_46json_2e83de1c),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/897d2975" /* webpackChunkName: "config_i18n_46config_46ts_897d2975" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/en.json",
        "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/en/errors.json"
      ]
    },
    {
      code: "pt",
      language: "pt-BR",
      name: "Português",
      files: [
        "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/pt.json",
        "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/pt/errors.json"
      ]
    }
  ],
  defaultLocale: "pt",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://app.zazos.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/en/errors.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt-BR",
    name: "Português",
    files: [
      {
        path: "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/pt.json",
        cache: undefined
      },
      {
        path: "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/i18n/locales/pt/errors.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/